import { Tooltip, TooltipProps } from "@mui/material";

import { cn } from "@utils/tailwind";

const PaperTooltip = ({ classes, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{
      ...classes,
      tooltip: cn(
        "p-3 mt-3 text-sm font-normal bg-white border shadow-lg border-neutral-400 text-neutral-700",
        classes?.tooltip
      ),
    }}
  />
);

export default PaperTooltip;
